import { cosmeticById } from "@zend/content";
import { decodeAssetImage, iconUrl, portraitUrl } from "../assets/manifest.js";

/** Offers show their supplied asset; non-model rewards are packaged in a rendered reward chest. */
export function cardArtAsset(art: string | null): { id: string; portrait: boolean } {
  const id = art?.startsWith("cos.")
    ? (cosmeticById(art).asset ?? "itm.chest_gold")
    : !art || art === "credits"
      ? "itm.chest_gold"
      : art;
  return { id, portrait: id.startsWith("unit.") };
}

export function cardArtUrl(art: string | null): string {
  const asset = cardArtAsset(art);
  return asset.portrait ? portraitUrl(asset.id) : iconUrl(asset.id);
}

const decoded = new Map<string, Promise<void>>();

/** Decode once before cached offer cards become visible; a failed asset remains retryable. */
export function preloadCardArt(arts: (string | null)[]): Promise<void> {
  const assets = new Map(arts.map((art) => [cardArtUrl(art), cardArtAsset(art)]));
  return Promise.all(
    [...assets].map(([url, asset]) => {
      let ready = decoded.get(url);
      if (!ready) {
        ready = decodeAssetImage(asset.id, asset.portrait).catch((error: unknown) => {
          decoded.delete(url);
          throw error;
        });
        decoded.set(url, ready);
      }
      return ready;
    }),
  ).then(() => undefined);
}
